export const getGlobalStyles = (palette) => {
  return {
    // NOTE: use this sparingly
    styles: `
      html {
        height: 100%;
        width: 100%;
      }
      "*" {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
      }
      body {
        background-color: ${palette.background.default};
        height: 100%;
        width: 100%;
      }
      a {
        color: ${palette.primary.main};
        text-decoration: none;
        cursor: pointer;
      }
      a:hover {
        color: ${palette.primary.main};
        text-decoration: underline;
      },
      #root {
        height: 100%;
        width: 100%;
      }
      ul {
        padding: 10px 20px;
      }
      button {
        cursor: pointer;
      }
    `,
  };
};
